export default {
  settings: {
    revokeOrder: "Commandes annulées",
    cancelList: "Liste des annulations",
  },
  revoke: {
    listTitle: "Commandes en annulation",
    storeInfo: "Marchand",
    orderAmount: "Montant",
    orderTotal: "Total",
    orderSource: "Source",
    contactPhone: "Téléphone",
    riderInfo: "Livreur",
    cancelling: "En cours",
    cancelled: "Annulée",
    rejected: "Refusée",
    cancelOrder: "Annuler",
    rejectOrder: "Refuser",
  },
  cancelReason: {
    listTitle: "Motifs d'annulation",
    add: "Ajouter",
    reason: "Motif",
    addTime: "Date",
  },
  detail: {
    title: "Détail de la commande",
    orderNo: "N° commande",
    orderDistance: "Distance",
    deliveryInfo: "Informations de livraison",
    storeName: "Nom du marchand",
    pushTime: "Heure de push",
    orderType: "Type de commande",
    takeaway: "Commande à emporter",
    actualAmount: "Montant payé",
    orderItems: "Détails de la commande",
    orderCode: "N° commande d'origine",
    seqPrefix: "N° séquence",
    orderChannel: "Canal",
    orderNote: "Remarque",
    goodsAmount: "Montant des articles",
    goodsDetail: "Articles",
    none: "Aucun",
    pickCode: "Code de retrait",
    pickPhoto: "Photo de retrait",
    receiveCode: "Code de réception",
    receivePhoto: "Photo de réception",
    locationInfo: "Adresses",
    riderInfo: "Livreur",
    riderName: "Nom du livreur",
    riderTel: "Téléphone du livreur",
    expectedIncome: "Revenu estimé",
    operationLog: "Journal des opérations",
    content: "Contenu",
    operateTime: "Heure",
  },
};
